import React from 'react';
import { StripeProvider, Elements } from 'react-stripe-elements';

import { Alert, Money } from '../../components';
import { CardForm, PaymentButton } from '../molecules';
import { useStripeState } from '../stripeState';

export function StripePayment() {
  const {
    stripe,
    processPayment,
    amount,
    currency,
    country,
    shippingAddress,
    error,
  } = useStripeState();

  return (
    <div className="mt-5">
      <p className="mt-2">
        Pay <strong><Money amount={amount} currency={currency} /></strong> by card.
      </p>

      {(!stripe || stripe === 'loading') && (
        <span>Loading...</span>
      )}

      {stripe && stripe !== 'loading' && amount > 0 && (
        <>
          {error?.message && <Alert type="error" {...error} />}

          <section id="payment">
            <StripeProvider stripe={stripe}>
              <Elements>
                <>
                  <PaymentButton
                    amount={amount}
                    currency={currency}
                    country={country}
                    processPayment={processPayment}
                    stripe={stripe}
                  />

                  <CardForm
                    shippingAddress={shippingAddress}
                    processPayment={processPayment}
                  />
                </>
              </Elements>
            </StripeProvider>
          </section>
        </>
      )}
    </div>
  );
}
